import OrientationAlert from "~/src/fullscreenModals/orientationAlert"
import {setVhProperty} from "./storeRealViewportHeight"
import { isMobile } from 'mobile-device-detect';
let orientationExit, mql;


const deviceOrientation = () => {
  if(mql) return
  mql = window.matchMedia("(orientation: portrait)");
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isSvt = userAgent.indexOf("svtduo") > -1 || window.location.hash.includes("svtduo")
  if(isSvt) return;
  // If there are matches, we're in portrait
  if (mql.matches && !orientationExit) {
    document.body?.classList.add("portrait")
    // Portrait orientation   
    orientationExit = OrientationAlert(); // this triggers the orientation alert AND returns the exit callback
  } else {
    document.body?.classList.remove("portrait")
    // Landscape orientation
    setVhProperty(); 
  }


  // Add a media query change listener
  mql.addListener(function (m) {
    if (m.matches) {
    document.body?.classList.add("portrait")
      if(!orientationExit) {
        orientationExit = OrientationAlert(); // this triggers the orientation alert AND returns the exit callback
      }

    } else {
    
        document.body?.classList.remove("portrait")
     document.dispatchEvent(new CustomEvent("portrait-change"));
      if(orientationExit) {
        orientationExit();
        orientationExit = null;
      }
    }
  });
};

export let mobileOrNot = () => {
  const isNewIpad =
  window.navigator.userAgent.match(/Mac/) &&
  window.navigator.maxTouchPoints &&
  window.navigator.maxTouchPoints > 2;
  // return window.outerWidth < 800
  deviceOrientation()
  const isMobileScreen = window.matchMedia("only screen and (max-width: 800px)");
  if (isMobile || isNewIpad || 
    isMobileScreen.matches
  ) {
    // true for mobile device
    return true;
  } else {
    // false for not mobile device
    return false;
  }
};
